import { render, staticRenderFns } from "./TextWithImageAndPoint.vue?vue&type=template&id=f3546588&scoped=true&"
import script from "./TextWithImageAndPoint.vue?vue&type=script&lang=js&"
export * from "./TextWithImageAndPoint.vue?vue&type=script&lang=js&"
import style0 from "./TextWithImageAndPoint.vue?vue&type=style&index=0&id=f3546588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3546588",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default,AppImage: require('/vercel/path0/components/general/AppImage.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
